import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Input,
  TextField,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import "react-phone-input-2/lib/bootstrap.css";
import { useEffect, useState } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { useNavigate } from "react-router-dom";

import useAuth from "../../hooks/useAuth";
// import { usePutUpdateProfileMutation } from "../../services/profile";
import { useSelector } from "react-redux";
import { getToken, setCredentials } from "../../reducers/authSlice";
import { useAppDispatch } from "../../hooks/store";
import {
  errorToast,
  getFromStorage,
  STORAGE_KEYS,
  successToast,
} from "../../helpers";
import { useFormik } from "formik";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { UploadMedia } from "../../utils/uploadMedia";
import {
  useLazyGetUserQuery,
  usePutUpdateProfileMutation,
} from "../../services/auth";
import { User } from "../../types/User";
import { media_url } from "../../helpers/constants/urls";
import Loader from "../../helpers/constants/Loader";
import useTranslation from "../../hooks/Translation";
const Profile = () => {
  const token: any = useSelector(getToken);
  const t = useTranslation();
  const dispatch = useAppDispatch();
  const user = useAuth();
  const navigate = useNavigate();
  const [updateprofile] = usePutUpdateProfileMutation();
  const [dialCode, setPhoneCode] = useState("+971");
  const [profile_picture, setProfilePicture] = useState<any>(null);
  const [imageId, setImageId] = useState(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [profileDetails, setProfileDetails] = useState<User>();
  const [getProfile] = useLazyGetUserQuery();

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    try {
      if (!file) {
        formik.setFieldValue("profile_picture", "");
        setProfilePicture("");
        setImageId(null);
        return;
      }
      setLoading(true);
      const res = await UploadMedia(file);
      if (res?.status === 200) {
        setLoading(false);
        console.log("url_id", res?.data);
        setImageId(res?.data[0]?.id);
        const imageUrl = res?.data[0]?.media_url;
        console.log("imageUrl", imageUrl);
        formik.setFieldValue("profile_picture", imageUrl);
        setProfilePicture(imageUrl);
        successToast("Image uploaded successfully.");
      } else {
        errorToast(res?.message);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setLoading(false);
      errorToast("Error uploading image. Please try again.");
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: user?.email || "",
      name: user?.full_name || "",
      phoneNo: user?.phone_no || "",
      profile_picture: user?.profile_picture?.media_url || "",
      dialCode: dialCode,
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required(t.error.emailReq)
        .matches(
          /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          t.error.validEmail
        )
        .matches(
          /^[^\uD800-\uDBFF\uD800-\uDBFF]+$/, // Regex to disallow emojis
          t.error.noEmoji
        ),
      name: Yup.string()
        .required(t.error.required)
        .min(2, t.error.minValidation)
        .max(40, t.error.max40)
        .test(
          "is-not-email",
          "Email address is not allowed in First Name",
          function (value) {
            return !Yup.string()
              .matches(
                /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
              )
              .isValidSync(value);
          }
        ),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      if (!formik.isValid) return;
      try {
        setSubmitting(true);
        const body = {
          email: values.email,
          full_name: values.name,
          // dialCode: values.dialCode,
          // phoneNo: values.phoneNo,
          media_url: values.profile_picture,
          user_role: 1,
          // phone_no: user?.phone_no,
          // country_code": "+1",
          profile_picture: imageId,
          profile_status: 5,
        };
        console.log("wefgwrgwrgwrgwg", body);
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await updateprofile(encryptedBody).unwrap();
        if (response?.status === 200) {
          const token = await getFromStorage(STORAGE_KEYS.token);

          dispatch(
            await setCredentials({
              user: response?.data,
              token: token || null,
            })
          );

          successToast(t.main.profileUpdated);
          navigate("/dashboard");
        } else {
          if (
            response?.status === 400 &&
            response?.message == "phone already exists"
          ) {
            errorToast(
              "Phone number already exists. Please use a different phone number."
            );
          } else {
            errorToast(response?.message || "Failed to update profile.");
          }
        }
      } catch (error) {
        errorToast("An error occurred while updating profile.");
      } finally {
        setSubmitting(false);
      }
    },
  });
  const profileApi = async () => {
    const token = await getFromStorage(STORAGE_KEYS.token);
    console.log(token);
    try {
      setLoading(true);
      const response = await getProfile({}).unwrap();
      if (response.status === 200) {
        dispatch(
          setCredentials({
            token: `${token}`,
            user: response?.data,
          })
        );
        setProfileDetails(response.data);
        setLoading(false);
      }
    } catch (e: any) {
      errorToast(e?.message || "");
      setLoading(false);
    }
  };
  useEffect(() => {
    // const token = getFromStorage(STORAGE_KEYS.token);
    // const userData = getFromStorage(STORAGE_KEYS.userData);
    // console.log("userData", userData);
    // if (token) {
    //   dispatch(
    //     setCredentials({
    //       token: `${token}`,
    //       user: null,
    //     })
    //   );
    profileApi();
    // }
  }, []);
  useEffect(() => {
    if (user?.profile_picture) {
      setImageId(user?.profile_picture?.id);
      setProfilePicture(user.profile_picture.media_url);
    }
    profileApi();
  }, [user]);

  return (
    <>
      <div>
        <div className="main_loyout">
          <div className="dashboard">
            <h1>{t.auth.editProfile}</h1>
          </div>
          <Loader loading={loading} />
          <Card className="cards">
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography className="custom_label">
                      {t.main.image}
                    </Typography>

                    <Box className="upload_image">
                      <label htmlFor="icon-button-file">
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file"
                          type="file"
                          inputProps={{
                            accept: "image/png,image/jpeg",
                          }}
                          onChange={handleImageUpload}
                        />

                        <Button component="span" className="upload_image_btn">
                          <img
                            src={
                              formik.values.profile_picture ||
                              `/static/images/user_placeholder.png`
                            }
                            alt="Profile"
                          />

                          <CameraAltIcon />
                        </Button>
                      </label>
                    </Box>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {t.main.fullName}
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="name"
                      variant="outlined"
                      fullWidth
                      placeholder={t.main.fullName}
                      className="text_field"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      helperText={formik.touched.name && formik.errors.name}
                      // error={formik.touched.name && Boolean(formik.errors.name)}
                      error={formik.touched.name && Boolean(formik.errors.name)}
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {t.main.email}
                    </Typography>
                    <TextField
                      hiddenLabel
                      type="email"
                      name="email"
                      variant="outlined"
                      fullWidth
                      placeholder={t.main.email}
                      className="text_field"
                      value={user?.email}
                      disabled
                      error={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                    ></TextField>
                  </Grid>
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    {t.main.save}
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
      </div>
    </>
  );
};

export default Profile;
